/** Public cosmetic payload only; never forward authoritative attack fields. */
export interface VolleyVisual {
  launch_x: number;
  launch_y: number;
  target_x: number;
  target_y: number;
  semi_major: number;
  semi_minor: number;
  rotation: number;
  launch_tick: number;
  impact_tick: number;
  seed: number;
  shot_count: number;
}

export function parseVolleyVisual(raw: unknown): VolleyVisual | undefined {
  if (raw == null) return undefined;
  try {
    const value = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!value || typeof value !== "object") return undefined;
    const fields = ["launch_x", "launch_y", "target_x", "target_y",
      "semi_major", "semi_minor", "rotation", "launch_tick", "impact_tick",
      "seed", "shot_count"] as const;
    const visual = {} as VolleyVisual;
    for (const key of fields) {
      if (typeof value[key] !== "number" || !Number.isFinite(value[key])) return undefined;
      visual[key] = value[key];
    }
    if (visual.semi_major < 0 || visual.semi_minor < 0
      || visual.impact_tick <= visual.launch_tick
      || visual.shot_count < 1 || !Number.isInteger(visual.shot_count)) return undefined;
    return visual;
  } catch {
    return undefined;
  }
}
